var Const = /** @class */ (function () {
    function Const() {
    }
    Const.RUN_GET_COUNTRIES_LIST = '/RUN_GET_COUNTRIES_LIST';
    Const.RUN_GET_CITIES_LIST = '/RUN_GET_CITIES_LIST';
    Const.RUN_GET_REFER_LINKS = '/RUN_GET_REFER_LINKS';
    Const.SET_COUNTRIES_LIST = '/SET_COUNTRIES_LIST';
    Const.GET_COUNTRIES_LIST = '/GET_COUNTRIES_LIST';
    Const.SET_CITIES_LIST = '/SET_CITIES_LIST';
    Const.GET_CITIES_LIST = '/GET_CITIES_LIST';
    //request access
    Const.RUN_REQUEST_OTP = '/RUN_REQUEST_OTP';
    Const.RUN_VERIFY_OTP = '/RUN_VERIFY_OTP';
    //document api
    Const.RUN_DOCUMENT_LINK_API = '/RUN_DOCUMENT_LINK_API';
    Const.RUN_DISABLE2FA = '/RUN_DISABLE2FA';
    //admin client
    Const.RUN_VERIFY_ADMIN = '/RUN_VERIFY_ADMIN';
    Const.RUN_DISABLE_ADMIN = '/RUN_DISABLE_ADMIN';
    Const.RUN_VERIFY_CLIENT = '/RUN_VERIFY_CLIENT';
    Const.RUN_DISABLE_CLIENT = '/RUN_DISABLE_CLIENT';
    //email
    Const.RUN_EMAIL_SETTING_LIST = '/RUN_EMAIL_SETTING_LIST';
    Const.RUN_ADD_EMAIL_SETTING = '/RUN_ADD_EMAIL_SETTING';
    Const.SET_EMAIL_SETTING_LIST = '/SET_EMAIL_SETTING_LIST';
    Const.GET_EMAIL_SETTING_LIST = '/GET_EMAIL_SETTING_LIST';
    //coupon
    Const.RUN_GET_COUPON_LIST = '/RUN_GET_COUPON_LIST';
    Const.RUN_CREATE_COUPON = '/RUN_CREATE_COUPON';
    Const.RUN_GET_PLAN_COUPON_LIST = '/RUN_GET_PLAN_COUPON_LIST';
    Const.RUN_SUB_EXSIST_LIST = '/RUN_SUB_EXSIST_LIST';
    Const.RUN_SUB_PLAN_LIST = '/RUN_SUB_PLAN_LIST';
    Const.RUN_SUB_PLAN_DETAIL = '/RUN_SUB_PLAN_DETAIL';
    Const.RUN_SUB_OPER = '/RUN_SUB_OPER';
    Const.RUN_UNSUBSCRIBE = '/RUN_UNSUBSCRIBE';
    Const.SET_COUPON_LIST = '/SET_COUPON_LIST';
    Const.GET_COUPON_LIST = '/GET_COUPON_LIST';
    Const.SET_SUB_PLAN_LIST = '/SET_SUB_PLAN_LIST';
    Const.GET_SUB_PLAN_LIST = '/GET_SUB_PLAN_LIST';
    Const.SET_SUB_PLAN_DETAIL = '/SET_SUB_PLAN_DETAIL';
    Const.GET_SUB_PLAN_DETAIL = '/GET_SUB_PLAN_DETAIL';
    Const.SET_SUB_EXSIST_LIST = '/SET_SUB_EXSIST_LIST';
    Const.GET_SUB_EXSIST_LIST = '/GET_SUB_EXSIST_LIST';
    //report
    Const.RUN_GET_REPORTING_LIST = '/RUN_GET_REPORTING_LIST';
    Const.RUN_CREATE_REPORT = '/RUN_CREATE_REPORT';
    Const.SET_REPORTING_LIST = '/SET_REPORTING_LIST';
    Const.GET_REPORTING_LIST = '/GET_REPORTING_LIST';
    Const.SET_EMIR_LIST = '/SET_EMIR_LIST';
    Const.GET_EMIR_LIST = '/GET_EMIR_LIST';
    //admin
    Const.RUN_GET_ADMIN_LIST = '/RUN_GET_ADMIN_LIST';
    Const.RUN_GET_ADMIN_DETAIL = '/RUN_GET_ADMIN_DETAIL';
    Const.RUN_ADD_ADMIN = '/RUN_ADD_ADMIN';
    Const.RUN_UPDATE_ADMIN_DETAIL = '/RUN_UPDATE_ADMIN_DETAIL';
    Const.SET_ADMIN_LIST = '/SET_ADMIN_LIST';
    Const.GET_ADMIN_LIST = '/GET_ADMIN_LIST';
    Const.SET_ADMIN_DETAIL = '/SET_ADMIN_DETAIL';
    Const.GET_ADMIN_DETAIL = '/GET_ADMIN_DETAIL';
    //faq
    Const.RUN_CREATE_CATEGORY = '/RUN_CREATE_CATEGORY';
    Const.RUN_CREATE_ARTICLE = '/RUN_CREATE_ARTICLE';
    Const.RUN_GET_ARTICLE_LIST = '/RUN_GET_ARTICLE_LIST';
    Const.RUN_GET_CAT_LIST = '/RUN_GET_CAT_LIST';
    Const.RUN_GET_CAT_DETAIL = '/RUN_GET_CAT_DETAIL';
    Const.RUN_GET_ARTICLE_DETAIL = '/RUN_GET_ARTICLE_DETAIL';
    Const.SET_ARTICLE_LIST = '/SET_ARTICLE_LIST';
    Const.GET_ARTICLE_LIST = '/GET_ARTICLE_LIST';
    Const.SET_CAT_LIST = '/SET_CAT_LIST';
    Const.GET_CAT_LIST = '/GET_CAT_LIST';
    //client
    Const.RUN_GET_ACCOUNT_DETAIL = '/RUN_GET_ACCOUNT_DETAIL';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE = '/SET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE = '/GET_WITHDRAWAL_METHOD_RESPONSE';
    Const.CALL_USER = '/CALL_USER';
    Const.RUN_GET_USER_LIST = '/RUN_GET_USER_LIST';
    Const.RUN_CREATE_CLIENT = '/RUN_CREATE_CLIENT';
    Const.RUN_WITHDRAWAL_METHODS = '/RUN_WITHDRAWAL_METHODS';
    Const.RUN_GET_LOGS_LIST = '/RUN_GET_LOGS_LIST';
    Const.RUN_GET_LOGS_VIEW = '/RUN_GET_LOGS_VIEW';
    Const.RUN_GET_LOGS_DETAIL = '/RUN_GET_LOGS_DETAIL';
    Const.RUN_GET_USER_VIEW = '/RUN_GET_USER_VIEW';
    Const.RUN_UPDATE_CLIENT_DETAIL = '/RUN_UPDATE_CLIENT_DETAIL';
    Const.RUN_RESET_PASSWORD = '/RUN_RESET_PASSWORD';
    Const.RUN_USER_COUNT = '/RUN_USER_COUNT';
    Const.RUN_USER_NOTIFICATIONS = '/RUN_USER_NOTIFICATIONS';
    Const.RUN_ADD_WITHDRAWAL = '/RUN_ADD_WITHDRAWAL';
    Const.RUN_ADD_TICKET = '/RUN_ADD_TICKET';
    Const.RUN_GET_INTERNAL_NOTES = '/RUN_GET_INTERNAL_NOTES';
    Const.RUN_ADD_INTERNAL_NOTES = '/RUN_ADD_INTERNAL_NOTES';
    Const.RUN_GET_RISK_METRIX = '/RUN_GET_RISK_METRIX';
    Const.RUN_VERIFY_ACCOUNT = '/RUN_VERIFY_ACCOUNT';
    Const.RUN_CREATE_TRADING_ACCOUNT = '/RUN_CREATE_TRADING_ACCOUNT';
    Const.SET_USER_LIST = '/SET_USER_LIST';
    Const.GET_USER_LIST = '/GET_USER_LIST';
    Const.SET_LOGS_LIST = '/SET_LOGS_LIST';
    Const.GET_LOGS_LIST = '/GET_LOGS_LIST';
    Const.SET_USER_VIEW = '/SET_USER_VIEW';
    Const.GET_USER_VIEW = '/GET_USER_VIEW';
    Const.SET_USER_COUNT = '/SET_USER_COUNT';
    Const.GET_USER_COUNT = '/GET_USER_COUNT';
    Const.SET_INTERNAL_NOTES = '/SET_INTERNAL_NOTES';
    Const.GET_INTERNAL_NOTES = '/GET_INTERNAL_NOTES';
    Const.SET_RISK_METRIX = '/SET_RISK_METRIX';
    Const.GET_RISK_METRIX = '/GET_RISK_METRIX';
    Const.SET_LOGS_VIEW = '/SET_LOGS_VIEW';
    Const.GET_LOGS_VIEW = '/GET_LOGS_VIEW';
    Const.GET_EMP_STATUS = '/GET_EMP_STATUS';
    Const.GET_OCCUPATION = '/GET_OCCUPATION';
    Const.GET_EST_YEARLY_INCOME = '/GET_EST_YEARLY_INCOME';
    Const.GET_EST_NET_WORTH = '/GET_EST_NET_WORTH';
    Const.GET_ACCOUNT_TURNOVER = '/GET_ACCOUNT_TURNOVER';
    Const.GET_GENDER_LIST = '/GET_GENDER_LIST';
    Const.GET_IDEN_VER = '/GET_IDEN_VER';
    Const.GET_FUND_SRC = '/GET_FUND_SRC';
    Const.GET_DEPT_METHD = '/GET_DEPT_METHD';
    Const.GET_CRED_INS = '/GET_CRED_INS';
    Const.GET_CHNL_RSK = '/GET_CHNL_RSK';
    Const.GET_THRD_PARTY = '/GET_THRD_PARTY';
    Const.GET_STEP = '/GET_STEP';
    Const.GET_TIMEZONE = '/GET_TIMEZONE';
    //deposit
    Const.RUN_CREATE_DEPOSIT = '/RUN_CREATE_DEPOSIT';
    Const.RUN_GET_DEPOSIT_LIST = '/RUN_GET_DEPOSIT_LIST';
    Const.RUN_GET_DEPOSIT_TRANSACTION = '/RUN_GET_DEPOSIT_TRANSACTION';
    Const.RUN_GET_DEPOSIT_VIEW = '/RUN_GET_DEPOSIT_VIEW';
    Const.RUN_EDIT_DEPOSIT_DETAILS = '/RUN_EDIT_DEPOSIT_DETAILS';
    Const.RUN_GET_DEPOSIT_TRANSACTION_STATUS = '/RUN_GET_DEPOSIT_TRANSACTION_STATUS';
    Const.SET_DEPOSIT_LIST = '/SET_DEPOSIT_LIST';
    Const.GET_DEPOSIT_LIST = '/GET_DEPOSIT_LIST';
    Const.SET_DEPOSIT_TRANSACTION = '/SET_DEPOSIT_TRANSACTION';
    Const.GET_DEPOSIT_TRANSACTION = '/GET_DEPOSIT_TRANSACTION';
    Const.SET_DEPOSIT_VIEW = '/SET_DEPOSIT_VIEW';
    Const.GET_DEPOSIT_VIEW = '/GET_DEPOSIT_VIEW';
    Const.GET_DEPOSIT_STATUS = '/GET_DEPOSIT_STATUS';
    Const.GET_DEPOSIT_METHOD = '/GET_DEPOSIT_METHOD';
    //commission
    Const.RUN_GET_COMMISSION_LIST = '/RUN_GET_COMMISSION_LIST';
    Const.RUN_GET_COMMISSION_VIEW = '/RUN_GET_COMMISSION_VIEW';
    Const.RUN_GET_COMMISSION_UPDATE = '/RUN_GET_COMMISSION_UPDATE';
    Const.SET_COMMISSION_LIST = '/SET_COMMISSION_LIST';
    Const.GET_COMMISSION_LIST = '/GET_COMMISSION_LIST';
    Const.SET_COMMISSION_VIEW = '/SET_COMMISSION_VIEW';
    Const.GET_COMMISSION_VIEW = '/GET_COMMISSION_VIEW';
    //bonus
    Const.RUN_GET_BONUS_LIST = '/RUN_GET_BONUS_LIST';
    Const.RUN_GET_BONUS_VIEW = '/RUN_GET_BONUS_VIEW';
    Const.RUN_GET_BONUS_UPDATE = '/RUN_GET_BONUS_UPDATE';
    Const.RUN_ADD_BONUS = '/RUN_ADD_BONUS';
    Const.RUN_GET_BONUS_DISABLE = '/RUN_GET_BONUS_DISABLE';
    Const.SET_BONUS_LIST = '/SET_BONUS_LIST';
    Const.GET_BONUS_LIST = '/GET_BONUS_LIST';
    Const.SET_BONUS_VIEW = '/SET_BONUS_VIEW';
    Const.GET_BONUS_VIEW = '/GET_BONUS_VIEW';
    //ticket
    Const.RUN_GET_TICKET_LIST = '/RUN_GET_TICKET_LIST';
    Const.RUN_GET_TICKET_VIEW = '/RUN_GET_TICKET_VIEW';
    Const.RUN_TICKET_REASON_LIST = '/RUN_TICKET_REASON_LIST';
    Const.RUN_TICKET_REPLY = '/RUN_TICKET_REPLY';
    Const.RUN_TICKET_APPROVE = '/RUN_TICKET_APPROVE';
    Const.RUN_TICKET_TRANSFER = '/RUN_TICKET_TRANSFER';
    Const.RUN_CLOSE_TICKET = '/RUN_CLOSE_TICKET';
    Const.RUN_TICKET_DOC_APPROVE_REJECT = '/RUN_TICKET_DOC_APPROVE_REJECT';
    //zip
    Const.GET_ZIP_DOCS_LINK = '/GET_ZIP_DOCS_LINK';
    Const.SET_TICKET_LIST = '/SET_TICKET_LIST';
    Const.GET_TICKET_LIST = '/GET_TICKET_LIST';
    Const.SET_TICKET_REASON_LIST = '/SET_TICKET_REASON_LIST';
    Const.GET_TICKET_REASON_LIST = '/GET_TICKET_REASON_LIST';
    Const.SET_TICKET_VIEW = '/SET_TICKET_VIEW';
    Const.GET_TICKET_VIEW = '/GET_TICKET_VIEW';
    Const.SET_TICKET_DOCS = '/SET_TICKET_DOCS';
    Const.GET_TICKET_DOCS = '/GET_TICKET_DOCS';
    Const.GET_TICKET_DOCS_LINK = '/GET_TICKET_DOCS_LINK';
    Const.GET_DEPARMENT_LIST = '/GET_DEPARMENT_LIST';
    Const.GET_TICKET_STATUS = '/GET_TICKET_STATUS';
    Const.GET_TICKET_REASON = '/GET_TICKET_REASON';
    //withdrawal
    Const.RUN_GET_WITHDRAWAL_LIST = '/RUN_GET_WITHDRAWAL_LIST';
    Const.RUN_GET_WITHDRAWAL_VIEW = '/RUN_GET_WITHDRAWAL_VIEW';
    Const.RUN_EDIT_WITHDRAWAL_DETAILS = '/RUN_EDIT_WITHDRAWAL_DETAILS';
    Const.SET_WITHDRAWAL_LIST = '/SET_WITHDRAWAL_LIST';
    Const.GET_WITHDRAWAL_LIST = '/GET_WITHDRAWAL_LIST';
    Const.SET_WITHDRAWAL_VIEW = '/SET_WITHDRAWAL_VIEW';
    Const.GET_WITHDRAWAL_VIEW = '/GET_WITHDRAWAL_VIEW';
    Const.GET_WITHDRAWAL_TYPE = '/GET_WITHDRAWAL_TYPE';
    Const.GET_WITHDRAWAL_METHOD = '/GET_WITHDRAWAL_METHOD';
    Const.GET_WITHDRAWAL_METHODS = '/GET_WITHDRAWAL_METHODS';
    Const.GET_WITHDRAWAL_STATUS = '/GET_WITHDRAWAL_STATUS';
    //trading
    Const.RUN_GET_TRADING_LIST = '/RUN_GET_TRADING_LIST';
    Const.RUN_GET_TRADING_VIEW = '/RUN_GET_TRADING_VIEW';
    Const.RUN_EDIT_TRADING_DETAILS = '/RUN_EDIT_TRADING_DETAILS';
    Const.RUN_DISABLE_TRADING_ACCOUNT = '/RUN_DISABLE_TRADING_ACCOUNT';
    Const.RUN_CHANGE_LEVERAGE = '/RUN_CHANGE_LEVERAGE';
    /*public static RUN_DELETE_TRADING_ACCOUNT:string  = '/RUN_DELETE_TRADING_ACCOUNT'*/
    Const.SET_TRADING_LIST = '/SET_TRADING_LIST';
    Const.GET_TRADING_LIST = '/GET_TRADING_LIST';
    Const.SET_TRADING_VIEW = '/SET_TRADING_VIEW';
    Const.GET_TRADING_VIEW = '/GET_TRADING_VIEW';
    Const.GET_DEMO_LIVE = '/GET_DEMO_LIVE';
    Const.GET_CURRENCY = '/GET_CURRENCY';
    //bonus
    Const.GET_BONUS_TYPE = '/GET_BONUS_TYPE';
    Const.GET_BONUS_STATUS = '/GET_BONUS_STATUS';
    Const.GET_NOTIFICATION_LISTING = '/GET_NOTIFICATION_LISTING';
    Const.SET_NOTIFICATION_LISTING = '/SET_NOTIFICATION_LISTING';
    Const.RUN_GET_NOTIFICATION_LISTING = '/RUN_GET_NOTIFICATION_LISTING';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/provider/candle-history/lib/const.cls.ts
// module id = null
// module chunks = 